import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Signup() {
  const [form,    setForm]    = useState({ email:'', password:'', name:'', companyName:'' });
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate   = useNavigate();

  const update = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signup(form);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Signup failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--bg-deep)',
      backgroundImage: `radial-gradient(ellipse at 40% 80%, rgba(95,255,200,0.04) 0%, transparent 60%)`
    }}>
      <div style={{ width: '100%', maxWidth: 420, padding: '0 20px' }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 32, fontWeight: 700, color: 'var(--text-primary)' }}>
            Sig<span style={{ color: 'var(--accent-purple)' }}>nal</span>
          </div>
          <div style={{ fontSize: 11, color: 'var(--text-dim)', fontFamily: 'var(--font-mono)',
                        letterSpacing: '3px', textTransform: 'uppercase', marginTop: 8 }}>
            Start Your Intelligence Layer
          </div>
        </div>

        <div className="card">
          <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 24, color: 'var(--text-primary)' }}>
            Create Account
          </h2>

          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
              <div>
                <label className="label">Your Name</label>
                <input type="text" required placeholder="Jane Smith"
                       value={form.name} onChange={update('name')} />
              </div>
              <div>
                <label className="label">Company / Brand</label>
                <input type="text" required placeholder="Acme Inc."
                       value={form.companyName} onChange={update('companyName')} />
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label className="label">Email</label>
              <input type="email" required placeholder="you@company.com"
                     value={form.email} onChange={update('email')} />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label className="label">Password (8+ characters)</label>
              <input type="password" required minLength={8} placeholder="••••••••"
                     value={form.password} onChange={update('password')} />
            </div>

            {error && (
              <div style={{ marginBottom: 16, padding: '10px 14px', background: 'rgba(255,107,107,0.08)',
                            border: '1px solid rgba(255,107,107,0.2)', borderRadius: 6,
                            fontSize: 13, color: 'var(--accent-red)' }}>
                {error}
              </div>
            )}

            <button
              type="submit" className="btn btn-primary"
              style={{ width: '100%', justifyContent: 'center' }}
              disabled={loading}
            >
              {loading ? <span className="pulsing">CREATING ACCOUNT...</span> : 'Create Account →'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text-dim)' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: 'var(--accent-purple)' }}>Sign in</Link>
        </div>

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 11, color: 'var(--text-dim)', opacity: 0.6 }}>
          By signing up you agree to our{' '}
          <Link to="/terms"   style={{ color: 'inherit' }}>Terms of Service</Link>
          {' '}and{' '}
          <Link to="/privacy" style={{ color: 'inherit' }}>Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
}
